import { Row, Col } from 'react-materialize';
import PropTypes from 'prop-types';

import './CustomLoader.css';

export default function CustomLoader({ message, zIndex = 10 }) {
  return (
    <div
      className="table-loader-overlay"
      style={{
        zIndex,
      }}
    >
      <Row className="loader__wrapper">
        <Col s={12}>
          <div className="lds-grid">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          {message && <div className="lds-message">{message}</div>}
        </Col>
      </Row>
    </div>
  );
}

CustomLoader.propTypes = {
  message: PropTypes.string,
  zIndex: PropTypes.number,
};
